import About from '../components/About';
import { Box } from '@mui/material';

const AboutPage = () => {
  return (
    <Box sx={{ pt: 8 }}>
      <About />
    </Box>
  );
};

export default AboutPage;
